import { PayloadAction } from '@reduxjs/toolkit';
import { put, takeLeading } from 'redux-saga/effects';
import { genericBladeSubmit, GenericBladeSubmitPayload } from '@commblades/commblades';

import { startBladeNavigation } from '../../navigationSlice';
import Blades from '../Blades';

function* applicationStartBladeSubmitWorkSaga(action: PayloadAction<GenericBladeSubmitPayload>) {
    if (action.payload.id === 'get-started') {
        yield put(startBladeNavigation(Blades.ApplicationStart.next));
    }
}

export function* applicationStartBladeSubmitWatchSaga() {
    yield takeLeading(genericBladeSubmit.type, applicationStartBladeSubmitWorkSaga);
}
